module.exports = __webpack_public_path__ + "img/wxacode.01dee52a.jpg";